<script>
  import { push } from 'svelte-spa-router';

  let formData = {
    email: ''
  };

  let errorMessage = '';
  let successMessage = '';
  let isLoading = false;

  async function handleSubmit(event) {
    event.preventDefault();
    errorMessage = '';
    successMessage = '';
    isLoading = true;

    console.log('=== FORGOT PASSWORD DEBUG INFO ===');
    console.log('Email:', formData.email);

    // Create a timeout wrapper for fetch
    const fetchWithTimeout = (url, options, timeout = 10000) => {
      return Promise.race([
        fetch(url, options),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error('Request timeout')), timeout)
        )
      ]);
    };

    try {
      console.log('Sending forgot password request...');
      
      const response = await fetchWithTimeout('/studentplayground/api/forgot-password/', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
      }, 15000);

      console.log('Received response:', response);

      if (response.ok) {
          console.log('Response OK:', response.status);
          
          const data = await response.json();
          console.log('Response data:', data);
          
          successMessage = data.message || 'Slaptažodžio atkūrimo instrukcijos išsiųstos į jūsų el. paštą.';
          
          // Clear the form
          formData.email = '';
          
      } else {
          console.warn('Response NOT OK:', response.status);
          
          const errorData = await response.json();
          console.log('Error data:', errorData);
          
          errorMessage = errorData.message || 'El. paštas nerastas sistemoje. Patikrinkite įvestį ir bandykite dar kartą.';
      }
    } catch (error) {
      console.error('Fetch error:', error);
      errorMessage = 'Klaida siunčiant užklausą. Patikrinkite interneto ryšį ir bandykite dar kartą.';
    } finally {
      isLoading = false;
    }

    console.log('Error message:', errorMessage);
    console.log('Success message:', successMessage);
  }

  function goBackToLogin() {
    push('/');
  }

  function handleBackToLoginKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      goBackToLogin();
    }
  }
</script>

<style>
  .background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: #fffffa;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 400px;
    margin: 20px auto
  }

  div {
    padding: 15px;
  }

  form {
    width: 90%;
    padding: 15px;
    background-color: #eeebdb;
    border-radius: 10px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form-title {
    color: #14695b;
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 12px;
    text-align: center;
  }

  .form-description {
    color: #14695b;
    font-size: 14px;
    margin-bottom: 15px;
    text-align: center;
    line-height: 1.3;
  }

  label {
    display: block;
    margin-top: 10px;
    font-weight: bold;
    align-self: baseline;
    color: #14695b;
  }

  input, button {
    width: -webkit-fill-available;
    display: block;
    padding: 10px;
    margin-top: 10px;
    border-radius: 5px;
    border: 1px solid #ddd;
  }

  button {
    background-color: #fab45a;
    color: #674a25;
    font-weight: bold;
    border: 1px solid;
    border-color: #674a25;
    height: 50px;
    cursor: pointer;
  }

  button:hover:not(:disabled) {
    background-color: #674a25;
    color: #fab45a;
    border-color: #fab45a;
  }

  button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .error-message {
    color: red;
    font-weight: bold;
    margin-top: 10px;
    text-align: center;
  }

  .success-message {
    color: green;
    font-weight: bold;
    margin-top: 10px;
    text-align: center;
  }

  .back-to-login {
    margin-top: 8px;
    text-align: center;
    color: #14695b;
    font-size: 14px;
    cursor: pointer;
    text-decoration: underline;
  }

  .back-to-login:hover,
  .back-to-login:focus {
    color: #fab45a;
    outline: none;
    text-decoration: none;
    font-weight: bold;
  }

  @media (max-aspect-ratio: 4/3) {
    .content {
      width: calc(100%-40px);
    }
  }

  @media (min-aspect-ratio: 4/3) {
    .content {
      width: 80%;
      margin: 40px auto 0;
    }
  }
</style>

<div class="background"></div>

<div class="content">
  <form on:submit={handleSubmit}>
    <img src="/static/images/Tutory Logo Black 1.png" alt="TUTORY Logo" class="logo" style="max-width: 200px;">
    
    <div class="form-title">Slaptažodžio atkūrimas</div>
    
    <div class="form-description">
      Įveskite savo el. pašto adresą ir mes atsiųsime jums naują slaptažodį.
    </div>
    
    <label for="email">El. pašto adresas</label>
    <input 
      type="email" 
      bind:value={formData.email} 
      placeholder="jusu@email.com"
      required
      disabled={isLoading}
    >
    
    <button type="submit" disabled={isLoading}>
      {isLoading ? 'Siunčiama...' : 'Atkurti slaptažodį'}
    </button>
    
    {#if errorMessage}
      <div class="error-message">{errorMessage}</div>
    {/if}
    
    {#if successMessage}
      <div class="success-message">{successMessage}</div>
    {/if}
  </form>
  
  <div 
    class="back-to-login" 
    on:click={goBackToLogin}
    on:keydown={handleBackToLoginKeydown}
    tabindex="0"
    role="button"
  >
    ← Grįžti į prisijungimą
  </div>
</div>
